// Offline Support (120): wire connectivity changes to the score write-queue.
//
// Called once at app boot. Drains any queued score writes on load (covers
// items left over from a previous session) and again whenever the browser
// reports the connection has returned. The queue itself owns ordering and
// rejection handling; this just supplies the "now is a good time to retry"
// signal. See decision 6 (reconnect-triggered replay).

import { onConnectivityChange, isOnline } from "./connectivity";
import { drainScoreQueueOnline } from "../api";
import { logger } from "../logger";

let started = false;

export function initOfflineSync(): void {
  if (started || typeof window === "undefined") return;
  started = true;

  if (isOnline()) {
    void drainScoreQueueOnline().catch(() => {});
  }

  onConnectivityChange((online) => {
    if (online) {
      logger.info("connection restored -- draining score queue");
      void drainScoreQueueOnline().catch(() => {});
    }
  });
}
